export type ReportEmptyKind = "empty" | "dateRange" | "filtered";

/** Presentation only. Does not change which rows the report query returns. */
export function reportEmptyKind(input: {
  narrowed: boolean;
  explicitDateRange: boolean;
}): ReportEmptyKind {
  if (input.narrowed) return "filtered";
  if (input.explicitDateRange) return "dateRange";
  return "empty";
}

export function contactImportReportEmptyKind(query: {
  search: string;
  from?: string;
  to?: string;
}): ReportEmptyKind {
  return reportEmptyKind({
    narrowed: Boolean(query.search.trim()),
    explicitDateRange: Boolean(query.from || query.to),
  });
}

export function campaignReportEmptyKind(query: {
  search: string;
  status?: string;
  endpointId?: number;
  template?: string;
  from?: string;
  to?: string;
}): ReportEmptyKind {
  return reportEmptyKind({
    narrowed: Boolean(query.search || query.status || query.endpointId != null || query.template),
    explicitDateRange: Boolean(query.from || query.to),
  });
}

export function outgoingReportEmptyKind(query: {
  search: string;
  from?: string;
  to?: string;
  platform?: string;
  origin?: string;
  statusBucket?: string;
  status?: string;
  endpointId?: number;
  campaignId?: number;
  template?: string;
}): ReportEmptyKind {
  return reportEmptyKind({
    narrowed: Boolean(
      query.search.trim() ||
        query.platform ||
        query.origin ||
        query.statusBucket ||
        query.status ||
        query.endpointId != null ||
        query.campaignId != null ||
        query.template?.trim(),
    ),
    explicitDateRange: Boolean(query.from || query.to),
  });
}

export function incomingReportEmptyKind(query: {
  search: string;
  from?: string;
  to?: string;
  platform?: string;
  endpointId?: number;
  messageType?: string;
}): ReportEmptyKind {
  return reportEmptyKind({
    narrowed: Boolean(
      query.search.trim() || query.platform || query.endpointId != null || query.messageType,
    ),
    explicitDateRange: Boolean(query.from || query.to),
  });
}

export function messageLogEmptyKind(query: {
  search: string;
  from?: string;
  to?: string;
  platform?: string;
  direction?: string;
  origin?: string;
  status?: string;
  messageType?: string;
  endpointId?: number;
  campaignId?: number;
  template?: string;
}): ReportEmptyKind {
  return reportEmptyKind({
    narrowed: Boolean(
      query.search.trim() ||
        query.platform ||
        query.direction ||
        query.origin ||
        query.status ||
        query.messageType ||
        query.endpointId != null ||
        query.campaignId != null ||
        query.template?.trim(),
    ),
    explicitDateRange: Boolean(query.from || query.to),
  });
}
